export default "__VITE_ASSET__BWPVz$XE__"